"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Contentpdf = function Contentpdf(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ContentpdfTitle ContentpdfDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ContentpdfTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ContentpdfDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M18.819.192H5.033c-1.402 0-2.342 1.242-2.342 2.643v18.387c0 1.402.96 2.595 2.365 2.595 0 0 10.88 0 10.963-.054a5.553 5.553 0 0 0 5.229-5.54V2.834c0-1.395-1.024-2.643-2.429-2.643v.001zm-3.037 17.28c-.355 0-.586.64-.586.982v4.138H5.036c-.698 0-1.069-.672-1.069-1.366V2.836c0-.698.368-1.363 1.062-1.363h13.789c.698 0 1.149.666 1.149 1.363v14.637h-4.182l-.003-.001zm.666 4.96v-3.68H20c-.352 1.92-1.632 3.405-3.552 3.68z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M5.114 8.24v-.006c0-.292.236-.528.528-.528h1.453c1.155 0 1.856.685 1.856 1.674 0 1.123-.874 1.702-1.958 1.702h-.81v.96a.534.534 0 0 1-1.066.002V8.241l-.003-.001zm1.92 1.92a.75.75 0 0 0 .845-.732v-.001c0-.477-.32-.733-.864-.733h-.832v1.482h.845l.006-.016zm2.707-1.92v-.006c0-.292.236-.528.528-.528h1.363c1.523 0 2.56 1.046 2.56 2.41 0 1.363-1.053 2.422-2.56 2.422h-1.366a.527.527 0 0 1-.528-.528V8.24h.003zm1.891 3.35a1.378 1.378 0 0 0 1.459-1.45v.003a1.392 1.392 0 0 0-1.39-1.461l-.072.002h-.822v2.922h.822l.003-.016zm3.523-3.35v-.006c0-.292.236-.528.528-.528H18.4a.484.484 0 0 1 .003.96h-2.181v1.03h1.859a.486.486 0 0 1 .539.48.483.483 0 0 1-.541.48h-1.857v1.408a.534.534 0 0 1-1.066.002V8.24h-.001z"
  }));
};

Contentpdf.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Contentpdf.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Contentpdf;
exports["default"] = _default;